<template>
  <div class="rm-layout">
    <Navbar :unread-count="unreadCount" />
    <div class="rm-layout__page">
      <AppMain />
    </div>
  </div>
</template>

<script>
import { getSysNoticeUnReadNum } from '@/api/notice'
import AppMain from './components/AppMain.vue'
import Navbar from './components/Navbar.vue'

export default {
  name: 'Layout',
  components: { AppMain, Navbar },
  data () {
    return { unreadCount: 0 }
  },
  created () {
    this.fetchUnreadCount()
    this.$root.$on('notice:refreshUnread', this.fetchUnreadCount)
  },
  beforeDestroy () {
    this.$root.$off('notice:refreshUnread', this.fetchUnreadCount)
  },
  methods: {
    async fetchUnreadCount () {
      try {
        const res = await getSysNoticeUnReadNum()
        this.unreadCount = Number(res.data || 0)
      } catch (error) {
        this.unreadCount = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rm-layout {
  background: #f5f7fa;
}

.rm-layout__page {
  padding: 30px 20px 20px;
  width: 99%;
  margin: 0 auto;
  overflow-x: visible;
}
</style>
